(function (angular, undefined) {
    'use strict';

    angular
        .module('blocks.loading', []);
})(angular);